import merge from '../../utilities/merge'
import { actionTypes } from '../actionTypes'
import { actionCreatorForActionType } from './generators'
import oldActionCreators from './old_actions'

// 4. create (also flat) action creators, need to be mapped to dispatch
export const actionCreators = merge(Object.keys(actionTypes).map(key => actionCreatorForActionType(key)))
// 4.1 you can add custom ones to these if you really want
// 4.5 merge (for now) with the existing old style ones
const allActionCreators = { ...oldActionCreators, ...actionCreators }
// 5 export/import as actionCreators
export default allActionCreators

global.KF = { ...global.KF, oldActionCreators, allActionCreators, actionCreators }



// WEBPACK FOOTER //
// ./src/redux/actionCreators/index.js